import artifact from '$houdini/artifacts/CreateDashboardChart'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateDashboardChartStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
